<template>
  <div>
    <b-row class="content-header mb-2">
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb />
      </b-col>
      <b-col class="content-header-right text-md-right" md="3" cols="12">
        <b-button
            @click="showFormModal(null)"
            class="px-3 text-capitalize"
            variant="primary"
        >
          <feather-icon size="16" icon="PlusIcon" class="mr-50" />
          ارسال پیام واتس‌اپ
        </b-button>
      </b-col>
    </b-row>
    <div v-if="messages">
      <b-card body-class="p-0" class="mt-1">
        <table-head
            ref="messagesTableHeadComponent"
            :items="tableHeadings"
            @sort="sort"
        />
        <b-row
            class="py-1 mx-1 border-bottom"
            v-for="message in messages"
            :key="message.id"
        >
          <b-col class="d-flex align-items-center">
            {{ message.phone_number }}
          </b-col>
          <b-col class="d-flex align-items-center">
            {{ message.message }}
          </b-col>
          <b-col class="d-flex align-items-center">
            <span :class="message.status === 'sent' ? 'text-success' : 'text-danger'">
              {{ message.status === 'sent' ? 'ارسال شده' : 'ناموفق' }}
            </span>
          </b-col>
          <b-col class="d-flex align-items-center flex-row-reverse">
            {{ new Date(message.created_at).toLocaleString('fa-IR', { timeZone: 'Iran' })}}
          </b-col>
        </b-row>
      </b-card>
      <pagination
          ref="messagesPaginationComponent"
          v-model="page"
          :paginationData="paginationData"
      />
    </div>

    <b-sidebar
        width="890px"
        v-model="formModal"
        right
        backdrop
        shadow
        bg-variant="white"
    >
      <template #header>
        <div class="w-100">
          <div class="text-right">
            <b-button
                style="background-color: rgba(75, 75, 75, 0.12)"
                @click="formModal = false"
                variant="flat-dark"
                class="btn-icon rounded-circle mr-1"
            >
              <feather-icon icon="XIcon" size="20" />
            </b-button>
          </div>
          <div class="mr-1 sidebarHeaderTitleDiv">
            <h3>ارسال پیام واتس‌اپ</h3>
          </div>
        </div>
      </template>

      <b-container class="mb-3">
        <b-form-group>
          <label>نحوه انتخاب گیرندگان:</label>
          <b-form-radio-group
              v-model="inputType"
              :options="[
          { text: 'انتخاب از لیست کاربران', value: 'list' },
          { text: 'وارد کردن شماره تماس', value: 'manual' }
        ]"
          />
        </b-form-group>
        <!-- انتخاب گیرندگان -->
        <b-form-group v-if="inputType === 'list'">
          <label>انتخاب گیرندگان از لیست:</label>
          <v-select
              multiple
              id="receivers"
              :components="{ OpenIndicator }"
              class="bg-white"
              :clearable="false"
              v-model="messageInput.user_ids"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="users"
              placeholder="برای جستجو تایپ کنید"
              :get-option-label="(option) => `${option.full_name} - ${option.mobile}`"
              :reduce="user => user.id"
          >
            <template #option="{ full_name, mobile }">
              {{ full_name }}
              <br />
              <cite>{{ mobile }}</cite>
            </template>
          </v-select>
        </b-form-group>
        <!-- ورود دستی شماره -->
        <b-form-group v-else>
          <label>شماره‌های تماس:</label>
          <b-form-textarea
              style="direction: ltr"
              v-model="messageInput.phone_numbers"
              rows="3"
              placeholder="شماره‌ها را وارد کنید (هر شماره در یک خط)
                مثال:
                09123456789
                09187654321"
          />
          <small class="text-muted">هر شماره را در یک خط جداگانه وارد کنید. فرمت: +09xxxxxxxxx</small>
        </b-form-group>
        <!-- متن پیام -->
        <b-form-group>
          <label>متن پیام:</label>
          <b-form-textarea
              v-model="messageInput.message"
              rows="6"
              placeholder="متن پیام خود را وارد کنید..."
          />
          <div class="mt-2">
            <b-button
                v-if="messageInput.message"
                variant="danger"
                size="sm"
                @click="clearMessage"
            >
              پاک کردن متن
            </b-button>
            <label class="d-block mb-1">متن‌های آماده:</label>
            <div class="d-flex flex-wrap gap-2">
              <b-button
                  v-for="(msg, index) in predefinedMessages"
                  :key="index"
                  variant="outline-primary"
                  size="sm"
                  class="ml-1 mb-1"
                  @click="copyMessage(msg.text)"
              >
                {{ msg.title }}
              </b-button>
            </div>
          </div>
        </b-form-group>
      </b-container>



      <template #footer>
        <div class="d-flex align-items-center justify-content-end px-2 py-1">
          <b-button
              class="text-capitalize mr-2"
              @click="formModal = false"
              variant="outline-dark"
          >
            {{ $t("cancel") }}
          </b-button>
          <b-button variant="primary" @click="submitForm">
            <div v-if="submitLoading" class="px-1">
              <b-spinner small style="width: 1.3rem; height: 1.3rem" />
              <span class="sr-only">Loading...</span>
            </div>
            <span v-else class="text-capitalize">ارسال پیام</span>
          </b-button>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
// ... imports ...

import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BFormRadio, BFormRadioGroup
} from "bootstrap-vue";
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import Search from "@/components/Search.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";
import ImageCropper from "@/components/ImageCropper.vue";
import StorageService from "@/services/storage";

export default {
  components: {
    BFormRadioGroup,
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    Breadcrumb,
    Pagination,
    Search,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    ImageCropper,
    BFormRadio
  },
  data() {
    return {
      predefinedMessages: [


        {
          title: 'تور قشم',
          text: ` تفریحات قشم
          کشتی تفریحی قشم، تفریحات آبی و تورهای یک روزه هرمز و جزیره
          مقایسه و رزرو👇
roomtoor.com/event/city/qeshm

          09039503060
          09025772445`
        },
        {
          title: 'اقامتگاه قشم',
          text: `اجاره سوئیت و آپارتمان در قشم
          مقایسه و رزرو👇
roomtoor.com/space/city/qeshm

          09039503060
          09025772445`
        },
        {
          title: 'ترانسفر قشم',
          text: `
          رزرو ترانسفر قشم

          بندرعباس به قشم👇

roomtoor.com/car/city/bandarabbas

 فرودگاه قشم به قشم👇

roomtoor.com/car/city/qeshm

          09039503060
          09025772445`
        },
        {
          title: 'صورتحساب تفریحات',
          text: `روم تور | صورتحساب
            آقای/خانم ...
            صورتحساب شما برای '...' صادر شد
            تاریخ: 1403/10/10
            سانس: ساعت 20
            تعداد مهمان: 5
            مبلغ کل: 1,234,000 تومان

            شماره کارت: 6037691990563843
            شماره شبا: 090190000000116736018000
            بانک صادرات شرکت تجارت الکترونیک توران گستر
            شماره کارت: 5022291332102399
            بانک پاسارگاد – قنبرزاده`
        },
        {
          title: 'صورتحساب اقامتگاه',
          text: `روم تور | صورتحساب
            آقای/خانم ...
            صورتحساب شما برای '...' صادر شد
            تاریخ ورود : 1403/10/10
            تاریخ خروج : 1403/10/10

            تعداد مهمان: 5
               قیمت هر شب : 1,234,000 تومان
            مبلغ کل: 1,234,000 تومان

            شماره کارت: 6037691990563843
            شماره شبا: 090190000000116736018000
            بانک صادرات شرکت تجارت الکترونیک توران گستر
            شماره کارت: 5022291332102399
            بانک پاسارگاد – قنبرزاده`
        },
        {
          title: 'آبتین',
          text: `لینک کشتی تفریحی آبتین vip قشم 👇

https://roomtoor.com/event/cruise-177439

          09039503060
      `
        },
        {
          title: 'تارا',
          text: `لینک کشتی تفریحی تارا قشم 👇

https://roomtoor.com/event/cruise-156191

          09039503060
      `
        },
        {
          title: 'یوتاب',
          text: `لینک کشتی تفریحی یوتاب قشم 👇

https://roomtoor.com/event/cruise-371714

          09039503060
      `
        },
        {
          title: 'وفا',
          text: `لینک کشتی تفریحی وفا قشم 👇

https://roomtoor.com/event/cruise-819692

          09039503060
      `
        },
        {
          title: 'امیرکبیر',
          text: `لینک کشتی تفریحی امیر کبیر کیش 👇

https://roomtoor.com/event/cruise-991795

          09039503060
      `
        },
        {
          title: 'تور قشم گردی',
          text: `تور داخلی قشم گردی و هنگام (ترانسفر رایگان+لیدر محلی+ورودی) 👇

https://roomtoor.com/event/tour-181655

          09039503060
      `
        },
        {
          title: 'تور هرمز',
          text: `تور یک روزه جزیره هرمز از قشم و بندرعباس 👇

https://roomtoor.com/event/tour-422815

          09039503060
      `
        },
        {
          title: 'تور هرمزvip ',
          text: `تور یک روزه هرمز با کشتی تفریحی وفا - Vip 👇

https://roomtoor.com/event/tour-367351

          09039503060
      `
        },
        {
          title: 'کلوپ آبی  قشم ',
          text: `کلوپ های آبی قشم 👇

https://roomtoor.com/event/city/qeshm?filter[category]=water

          09039503060
      `
        },
        {
          title: 'تفریحات انزلی ',
          text: `کشتی تفریحی های شهر انزلی 👇

https://roomtoor.com/event/city/anzali

          09039503060
      `
        },
        {
          title: 'شکوفه',
          text: `کشتی تفریحی شکوفه انزلی 👇

https://roomtoor.com/event/cruise-848852

          09039503060
      `
        },
        {
          title: 'مایا ',
          text: `کشتی تفریحی مایا انزلی 👇

https://roomtoor.com/event/cruise-716563

          09039503060
      `
        },
        {
          title: 'مهتاب',
          text: `کشتی تفریحی مهتاب انزلی 👇

https://roomtoor.com/event/cruise-552249

          09039503060
      `
        },
        {
          title: 'تخت جمشید',
          text: `تور یک روزه تخت جمشید ، نقش رستم و پاسارگاد از شیراز 👇

https://roomtoor.com/event/tour-314781

          09039503060
      `
        },
        {
          title: 'موغلی',
          text: `اقامتگاه های شهر قشم 👇

https://roomtoor.com/host/wst8TfAY5A

          09039503060
      `
        },
        {
          title: 'آقایی',
          text: `اقامتگاه های شهر قشم 👇

https://roomtoor.com/host/SQDlk6vlOq

          09039503060
      `
        },
      ],
      submitLoading: false,
      formModal: false,
      page: 1,
      perPage: 10,
      messages: null,
      users: [],
      inputType: 'list',
      paginationData: null,
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      messageInput: {
        user_ids: [],
        phone_numbers: '',
        message: ''
      },
      tableHeadings: [
        {
          title: "شماره تماس",
          slug: "phone_number",
          sortable: true,
        },
        {
          title: "متن پیام",
          slug: "message",
          sortable: false,
        },
        {
          title: "وضعیت",
          slug: "status",
          sortable: true,
        },
        {
          title: "تاریخ ارسال",
          slug: "created_at",
          sortable: true,
        }
      ]
    };
  },
  mounted() {
    this.getMessages();
    this.getUsers();
  },
  methods: {
    clearMessage() {
      this.messageInput.message = '';
      this.$bvToast.toast('متن پاک شد', {
        title: 'موفق',
        variant: 'success',
        solid: true
      });
    },
    copyMessage(text) {
      this.messageInput.message = text;
      this.$bvToast.toast('متن با موفقیت کپی شد', {
        title: 'موفق',
        variant: 'success',
        solid: true
      });
    },

    async getUsers() {
      try {
        const response = await this.$http.get('/admin/users/get_total_users', {
          params: { per_page: 5000 }
        });
        this.users = response.data.data;
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    },

    async getMessages() {
      try {
        const response = await this.$http.get('/admin/whatsapp/messages', {
          params: {
            page: this.page,
            per_page: this.perPage,
            sort_by: this.sortBy,
            sort_dir: this.sortDir
          }
        });
        this.messages = response.data.data;
        this.paginationData = response.data.meta;
      } catch (error) {
        console.error('Error fetching messages:', error);
      }
    },

    async submitForm() {
      if (this.submitLoading) return;

      // اعتبارسنجی فرم
      if (!this.messageInput.message) {
        this.$bvToast.toast('لطفاً متن پیام را وارد کنید', {
          title: 'خطا',
          variant: 'danger',
          solid: true
        });
        return;
      }

      if (this.inputType === 'list' && !this.messageInput.user_ids.length) {
        this.$bvToast.toast('لطفاً حداقل یک گیرنده انتخاب کنید', {
          title: 'خطا',
          variant: 'danger',
          solid: true
        });
        return;
      }

      if (this.inputType === 'manual' && !this.messageInput.phone_numbers.trim()) {
        this.$bvToast.toast('لطفاً حداقل یک شماره تماس وارد کنید', {
          title: 'خطا',
          variant: 'danger',
          solid: true
        });
        return;
      }

      this.submitLoading = true;

      try {
        let endpoint = '/admin/whatsapp/send';
        let data = {
          message: this.messageInput.message
        };

        if (this.inputType === 'list') {
          endpoint += '/bulk';
          data.user_ids = this.messageInput.user_ids;
        } else {
          endpoint += '/manual';
          // تبدیل متن شماره‌ها به آرایه و حذف فضاهای خالی
          data.phone_numbers = this.messageInput.phone_numbers
              .split('\n')
              .map(number => number.trim())
              .filter(number => number); // حذف خطوط خالی
        }

        await this.$http.post(endpoint, data);

        this.$bvToast.toast('پیام با موفقیت ارسال شد', {
          title: 'موفق',
          variant: 'success',
          solid: true
        });

        this.formModal = false;
        this.getMessages();
      } catch (error) {
        this.$bvToast.toast(
            error.response?.data?.message || 'خطا در ارسال پیام',
            {
              title: 'خطا',
              variant: 'danger',
              solid: true
            }
        );
      } finally {
        this.submitLoading = false;
      }
    },

    showFormModal() {
      this.messageInput = {
        user_ids: [],
        phone_numbers: '',
        message: ''
      };
      this.inputType = 'list';
      this.formModal = true;
    },

    sort(args) {
      this.page = 1;
      this.sortBy = args.sortBy;
      this.sortDir = args.sortDir;
      this.getMessages();
    },


  }
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>